import React from "react";
import type { FieldError, Path, UseFormRegister, FieldValues } from "react-hook-form";

interface TextareaInputProps<TFormValues extends FieldValues> {
  id: string;
  name: Path<TFormValues>;
  label?: React.ReactNode;
  placeholder?: string;
  className?: string;
  register: UseFormRegister<TFormValues>;
  error?: FieldError;
}

const TextareaInput = <TFormValues extends FieldValues>({
  id,
  name,
  label,
  placeholder = "",
  className = "",
  register,
  error,
}: TextareaInputProps<TFormValues>) => (
  <div className={className}>
    <label className={`gcw:flex gcw:flex-col gcw:items-start gcw:w-full gcw:mb-bs-3 ${className}`} htmlFor={id}>
      {label}
    </label>
    <textarea id={id} className="gcw:w-full container-inputs" placeholder={placeholder} {...register(name)} />
    {error && <span>{error.message}</span>}
  </div>
);

export default TextareaInput;
